// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CV8ZQS {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-0-5);
  width: 100%;
}

.Y9bD5U {
  border: 1px dashed var(--stroke-neutral-silver, #cccccc);
  border-radius: var(--radius-s, 4px);
  padding: var(--spacing-3, 24px);
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  position: relative;
  background-color: var(--surface-neutral-pale, #fafafa);
  width: 100%;
  min-width: 144px;
  box-sizing: border-box;
}

.jBKm4w {
  --label-size: var(--font-size-md);
  --input-size: var(--font-size-md);
  --message-size: var(--font-size-sm);
  --input-padding-top: var(--spacing-2);
  --input-padding-bottom: var(--spacing-2);
}

.JXvV7G {
  --label-size: var(--font-size-sm);
  --input-size: var(--font-size-sm);
  --message-size: var(--font-size-sm);
  --input-padding-top: var(--spacing-1);
  --input-padding-bottom: var(--spacing-1);
}

.Y9bD5U:hover:not(.kjd1dA) {
  border-color: var(--stroke-neutral-stronger, #afafaf);
  background-color: var(--surface-neutral-subtle, #f5f5f5);
}

.Y9bD5U.i9W8UU {
  border-color: var(--color-primary, #ff6b35);
  background-color: var(--surface-primary-subtle, #fff5f2);
}

.Y9bD5U.i9W8UU .nzzZHJ .jv9wBm {
  color: var(--color-primary, #ff6b35);
}

.Y9bD5U.i9W8UU .nzzZHJ .Z2V2uA {
  color: var(--color-primary, #ff6b35);
}

.Y9bD5U.kjd1dA {
  cursor: not-allowed;
  opacity: 0.5;
}

.nzzZHJ {
  display: flex;
  flex-direction: column;
  align-items: center;
  border-color: #fafafa;
  gap: 12px;
}

.nzzZHJ .Z2V2uA {
  width: 16px;
  height: 16px;
  transition: color 0.3s ease-in-out;
}

.nzzZHJ .Z2V2uA img {
  width: 16px;
  height: 16px;
}

.nzzZHJ .jv9wBm {
  font-family: 'Source Sans 3', var(--font-family-base);
  font-weight: 500;
  font-size: 16px;
  line-height: 100%;
  color: #d64000;
  transition: color 0.3s ease-in-out;
}

.nzzZHJ .FlfEXY {
  font-family: 'Source Sans 3', var(--font-family-base);
  font-size: 12px;
  font-weight: 400;
  line-height: 100%;
  color: var(--text-neutral-stronger, #666666);
}

.L77Iu8 {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 8px;
  padding: 8px 12px;
  background-color: #f5f5f5;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
}

.KIVL3y {
  font-size: var(--font-size-sm, 12px);
  color: var(--color-primary, #ff6b35);
  font-weight: var(--font-weight-medium, 500);
  flex: 1;
  text-align: left;
  word-break: break-all;
}

.u7MJDG {
  background: none;
  border: none;
  cursor: pointer;
  width: 24px;
  height: 24px;
  min-width: 24px;
  max-width: 32px;
  min-height: 24px;
  max-height: 32px;
  padding: 4px;
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;
  flex-shrink: 0;
}

.u7MJDG img {
  width: 14px;
  height: 16px;
  filter: brightness(0) saturate(100%) invert(9%) sepia(5%) saturate(10%) hue-rotate(0deg) brightness(97%) contrast(93%);
}

.u7MJDG:hover {
  background-color: #e0e0e0;
}

.OAOPTL {
  position: relative;
  display: inline-block;
}

.OAOPTL img {
  max-width: 100%;
  max-height: 200px;
  border-radius: 6px;
}

.OTeJhZ {
  position: absolute;
  top: -16px;
  right: -8px;
  color: white;
  border: none;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 12px;
  transition: background-color 0.2s ease;
}

.OTeJhZ:hover {
  background: #cccccc;
}

.BLd6dS {
  margin-top: 20px;
  font-size: 12px;
  color: red;
}

.CXIr67 {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  gap: var(--spacing-0-5);
}

.KPUsla {
  height: 12px;
  width: 12px;
}

.XGdEOt {
  margin: 0;
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  color: var(--text-neutral-stronger);
  font-size: var(--message-size);
}

.rtTVq_ {
  width: 100%;
  height: 56px;
  padding: 8px 16px;
  background-color: #f5f5f5;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}

.iRL4CN {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 4px;
  width: 100%;
}

.JmfhPV {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  flex: 1;
  min-width: 0;
}

.mkfAEc {
  font-family: 'Source Sans 3', var(--font-family-base);
  font-size: 14px;
  font-weight: 400;
  line-height: 100%;
  color: var(--text-neutral-dark, #1f1f1f);
  word-break: break-word;
}

.GxVvqJ {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.rm1Nh8 {
  font-family: 'Source Sans 3', var(--font-family-base);
  font-size: 12px;
  font-weight: 400;
  line-height: 100%;
  color: var(--text-neutral-dark, #1f1f1f);
}

.fUSngf {
  font-family: 'Source Sans 3', var(--font-family-base);
  font-size: 12px;
  font-weight: 400;
  line-height: 100%;
  color: var(--text-neutral-dark, #1f1f1f);
}

.A16rnF {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.yAyFr4 {
  border: none;
  padding: 0;
  background-color: transparent;
}

.yAyFr4:hover:not(.kjd1dA) {
  border-color: transparent;
  background-color: transparent;
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/FileUpload/FileUpload.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,wDAAwD;EACxD,mCAAmC;EACnC,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB,sDAAsD;EACtD,WAAW;EACX,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,iCAAiC;EACjC,mCAAmC;EACnC,qCAAqC;EACrC,wCAAwC;AAC1C;;AAEA;EACE,iCAAiC;EACjC,iCAAiC;EACjC,mCAAmC;EACnC,qCAAqC;EACrC,wCAAwC;AAC1C;;AAEA;EACE,qDAAqD;EACrD,wDAAwD;AAC1D;;AAEA;EACE,2CAA2C;EAC3C,wDAAwD;AAC1D;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,qDAAqD;EACrD,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,qDAAqD;EACrD,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;EACpC,2CAA2C;EAC3C,OAAO;EACP,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sHAAsH;AACxH;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,uCAAuC;EACvC,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,OAAO;EACP,YAAY;AACd;;AAEA;EACE,qDAAqD;EACrD,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,qDAAqD;EACrD,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,qDAAqD;EACrD,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-0-5);\n  width: 100%;\n}\n\n.fileUpload {\n  border: 1px dashed var(--stroke-neutral-silver, #cccccc);\n  border-radius: var(--radius-s, 4px);\n  padding: var(--spacing-3, 24px);\n  text-align: center;\n  cursor: pointer;\n  transition: all 0.3s ease-in-out;\n  position: relative;\n  background-color: var(--surface-neutral-pale, #fafafa);\n  width: 100%;\n  min-width: 144px;\n  box-sizing: border-box;\n}\n\n.large {\n  --label-size: var(--font-size-md);\n  --input-size: var(--font-size-md);\n  --message-size: var(--font-size-sm);\n  --input-padding-top: var(--spacing-2);\n  --input-padding-bottom: var(--spacing-2);\n}\n\n.small {\n  --label-size: var(--font-size-sm);\n  --input-size: var(--font-size-sm);\n  --message-size: var(--font-size-sm);\n  --input-padding-top: var(--spacing-1);\n  --input-padding-bottom: var(--spacing-1);\n}\n\n.fileUpload:hover:not(.disabled) {\n  border-color: var(--stroke-neutral-stronger, #afafaf);\n  background-color: var(--surface-neutral-subtle, #f5f5f5);\n}\n\n.fileUpload.dragging {\n  border-color: var(--color-primary, #ff6b35);\n  background-color: var(--surface-primary-subtle, #fff5f2);\n}\n\n.fileUpload.dragging .fileUploadContent .title {\n  color: var(--color-primary, #ff6b35);\n}\n\n.fileUpload.dragging .fileUploadContent .icon {\n  color: var(--color-primary, #ff6b35);\n}\n\n.fileUpload.disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.fileUploadContent {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  border-color: #fafafa;\n  gap: 12px;\n}\n\n.fileUploadContent .icon {\n  width: 16px;\n  height: 16px;\n  transition: color 0.3s ease-in-out;\n}\n\n.fileUploadContent .icon :global(img) {\n  width: 16px;\n  height: 16px;\n}\n\n.fileUploadContent .title {\n  font-family: 'Source Sans 3', var(--font-family-base);\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 100%;\n  color: #d64000;\n  transition: color 0.3s ease-in-out;\n}\n\n.fileUploadContent .subtitle {\n  font-family: 'Source Sans 3', var(--font-family-base);\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 100%;\n  color: var(--text-neutral-stronger, #666666);\n}\n\n.fileInfo {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  margin-top: 8px;\n  padding: 8px 12px;\n  background-color: #f5f5f5;\n  border-radius: 4px;\n  border: 1px solid #e0e0e0;\n}\n\n.fileName {\n  font-size: var(--font-size-sm, 12px);\n  color: var(--color-primary, #ff6b35);\n  font-weight: var(--font-weight-medium, 500);\n  flex: 1;\n  text-align: left;\n  word-break: break-all;\n}\n\n.removeFileButton {\n  background: none;\n  border: none;\n  cursor: pointer;\n  width: 24px;\n  height: 24px;\n  min-width: 24px;\n  max-width: 32px;\n  min-height: 24px;\n  max-height: 32px;\n  padding: 4px;\n  border-radius: 2px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.2s ease;\n  flex-shrink: 0;\n}\n\n.removeFileButton img {\n  width: 14px;\n  height: 16px;\n  filter: brightness(0) saturate(100%) invert(9%) sepia(5%) saturate(10%) hue-rotate(0deg) brightness(97%) contrast(93%);\n}\n\n.removeFileButton:hover {\n  background-color: #e0e0e0;\n}\n\n.preview {\n  position: relative;\n  display: inline-block;\n}\n\n.preview img {\n  max-width: 100%;\n  max-height: 200px;\n  border-radius: 6px;\n}\n\n.removeButton {\n  position: absolute;\n  top: -16px;\n  right: -8px;\n  color: white;\n  border: none;\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 12px;\n  transition: background-color 0.2s ease;\n}\n\n.removeButton:hover {\n  background: #cccccc;\n}\n\n.error {\n  margin-top: 20px;\n  font-size: 12px;\n  color: red;\n}\n\n.messageContainer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  width: 100%;\n  gap: var(--spacing-0-5);\n}\n\n.messageIcon {\n  height: 12px;\n  width: 12px;\n}\n\n.message {\n  margin: 0;\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  color: var(--text-neutral-stronger);\n  font-size: var(--message-size);\n}\n\n.fileDetails {\n  width: 100%;\n  height: 56px;\n  padding: 8px 16px;\n  background-color: #f5f5f5;\n  border-radius: 4px;\n  border: 1px solid #e0e0e0;\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n}\n\n.fileDetailsContent {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 4px;\n  width: 100%;\n}\n\n.fileDetailsMain {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n  flex: 1;\n  min-width: 0;\n}\n\n.fileDetailsName {\n  font-family: 'Source Sans 3', var(--font-family-base);\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 100%;\n  color: var(--text-neutral-dark, #1f1f1f);\n  word-break: break-word;\n}\n\n.fileDetailsNameRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.fileDetailsDate {\n  font-family: 'Source Sans 3', var(--font-family-base);\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 100%;\n  color: var(--text-neutral-dark, #1f1f1f);\n}\n\n.fileDetailsSize {\n  font-family: 'Source Sans 3', var(--font-family-base);\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 100%;\n  color: var(--text-neutral-dark, #1f1f1f);\n}\n\n.fileDetailsSide {\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.fileUploadDetails {\n  border: none;\n  padding: 0;\n  background-color: transparent;\n}\n\n.fileUploadDetails:hover:not(.disabled) {\n  border-color: transparent;\n  background-color: transparent;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `CV8ZQS`,
	"fileUpload": `Y9bD5U`,
	"large": `jBKm4w`,
	"small": `JXvV7G`,
	"disabled": `kjd1dA`,
	"dragging": `i9W8UU`,
	"fileUploadContent": `nzzZHJ`,
	"title": `jv9wBm`,
	"icon": `Z2V2uA`,
	"subtitle": `FlfEXY`,
	"fileInfo": `L77Iu8`,
	"fileName": `KIVL3y`,
	"removeFileButton": `u7MJDG`,
	"preview": `OAOPTL`,
	"removeButton": `OTeJhZ`,
	"error": `BLd6dS`,
	"messageContainer": `CXIr67`,
	"messageIcon": `KPUsla`,
	"message": `XGdEOt`,
	"fileDetails": `rtTVq_`,
	"fileDetailsContent": `iRL4CN`,
	"fileDetailsMain": `JmfhPV`,
	"fileDetailsName": `mkfAEc`,
	"fileDetailsNameRow": `GxVvqJ`,
	"fileDetailsDate": `rm1Nh8`,
	"fileDetailsSize": `fUSngf`,
	"fileDetailsSide": `A16rnF`,
	"fileUploadDetails": `yAyFr4`
};
module.exports = ___CSS_LOADER_EXPORT___;
